export enum BusinessSectorType {
  Government = "GOVERNMENT",
  Commercial = "COMMERCIAL",
  Common = "COMMON"
}
